import { Component } from 'react';
import ErrorBanner from 'assets/images/error-banner.png';
import { ReactComponent as Square } from 'assets/images/svg/square.svg';
import { ReactComponent as Triangle } from 'assets/images/svg/triangle.svg';

export default class ErrorBoundary extends Component {
  constructor() {
    super();
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true,
      error: error,
      errorInfo: errorInfo,
    });
  }

  refreshPage = () => {
    window.location.reload();
  };

  renderErrorUI = () => {
    return (
      <div style={ { position: 'fixed' } }>
        <div className="icons">
          <div className="left-side">
            <Triangle className="triangle" />
            <Square className="square" />
          </div>
          <div className="right-side">
            <Triangle className="triangle" />
            <Square className="square" />
          </div>
        </div>
        <div className="error-boundary">
          <div className="error-banner-container">
            <img
              className="error-banner"
              src={ ErrorBanner }
              alt="Something went wrong"
            />
          </div>
          <div className="error-text">
            <b>OOPS!</b> SOMETHING WENT WRONG
          </div>
          <div className="action-buttons-container">
            <div className="action-btn" onClick={ this.refreshPage }>
              REFRESH PAGE
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return this.state.hasError ? this.renderErrorUI() : this.props.children;
  }
}
